export default __webpack_public_path__ + "static/media/pea_02-1.e5d76bc9.jpg";